// Rotas de PERMISSÃO de apps que vivem FORA da SPA do Hub (domínio próprio).
//
// Por que este arquivo existe: `syncFrontendRoutes` (authStore) desativa toda
// linha de `routes` ausente do payload construído a partir da árvore do Vue
// Router do Hub. Um app externo (CRM | CS) não está nessa árvore — sem esta
// lista, o primeiro login de admin master zeraria `is_active` nas rotas dele
// e o guard passaria a negar todo mundo, admin master incluído.
//
// A MESMA lista alimenta os `meta.permissionPath` do router do app CRM
// (ui/src/crm) — importar daqui é o que impede os dois lados de divergirem.
// Os paths são EXATAMENTE os semeados pela migration 190 em `routes`.

export interface ExternalAppRoute {
  path: string;
  name: string;
  title: string;
  requiresAuth: boolean;
  requiresAdminMaster: boolean;
}

export const CRM_CS_ROUTES: ExternalAppRoute[] = [
  {
    path: '/crm/cs',
    name: 'crm-cs-carteira',
    title: 'CRM | CS - Carteira',
    requiresAuth: true,
    requiresAdminMaster: false,
  },
  {
    path: '/crm/cs/conta/:id',
    name: 'crm-cs-conta',
    title: 'Ficha da Escola',
    requiresAuth: true,
    requiresAdminMaster: false,
  },
  {
    // ⚠ Chave PRÓPRIA, não a da carteira: `ver` no nó `montagem` dispensa o
    // recorte por responsável no módulo inteiro, então reusar `/crm/cs` seria
    // desligar o recorte para todo mundo que entra no CRM.
    path: '/crm/cs/montagem',
    name: 'crm-cs-montagem',
    title: 'CRM | CS - Montagem de carteiras',
    requiresAuth: true,
    requiresAdminMaster: false,
  },
  {
    path: '/crm/cs/medicoes',
    name: 'crm-cs-medicoes',
    title: 'Medições',
    requiresAuth: true,
    requiresAdminMaster: false,
  },
  {
    // Chave própria: a fila de chamados e a carteira têm públicos diferentes —
    // quem cuida da fila pode não mexer na carteira, e vice-versa.
    path: '/crm/cs/chamados',
    name: 'crm-cs-chamados',
    title: 'CRM | CS - Chamados',
    requiresAuth: true,
    requiresAdminMaster: false,
  },
  {
    // Reports (status da integração plataforma ↔ ERP + envios ao ERP).
    path: '/crm/cs/reports',
    name: 'crm-cs-reports',
    title: 'CRM | CS - Reports',
    requiresAuth: true,
    requiresAdminMaster: false,
  },
  {
    path: '/crm/cs/admin/sync',
    name: 'crm-cs-sync',
    title: 'CRM CS - Sincronização',
    requiresAuth: true,
    requiresAdminMaster: false,
  },
  {
    path: '/crm/cs/admin/parametros',
    name: 'crm-cs-parametros',
    title: 'CRM | CS - Parâmetros do Protheus',
    requiresAuth: true,
    requiresAdminMaster: false,
  },
  {
    path: '/crm/cs/permissoes',
    name: 'crm-cs-permissoes',
    title: 'CRM | CS - Permissões',
    requiresAuth: true,
    requiresAdminMaster: false,
  },
];

export const EXTERNAL_APP_ROUTES: ExternalAppRoute[] = [...CRM_CS_ROUTES];
